import { graphql } from "gatsby"
import React from "react"
import { useTranslation } from "react-i18next"

import InfoBoxAlt from "@knowit-alma/common/src/components/molecules/InfoBoxAlt/InfoBoxAlt"

const AuthorBox = ({ blockDataAuthorBox }) => {
  const { t } = useTranslation()

  const { author } = blockDataAuthorBox || {}

  const personMeta = author ? author.personMeta : {}

  const link = personMeta.archivelinktext
    ? {
        title: personMeta.archivelinktext,
        url: author?.uri,
      }
    : null

  return (
    <InfoBoxAlt
      heading={`${t("Author")} ${personMeta.name}`}
      list={personMeta.bulletlist?.split("\r\n")}
      link={link}
    />
  )
}
export const query = graphql`
  fragment AuthorBox on WpBlockAcfAuthorBox {
    __typename
    blockDataAuthorBox {
      author {
        ... on WpPerson {
          uri
          personMeta {
            name
            bulletlist
            archivelinktext
          }
        }
      }
    }
  }
`

export default AuthorBox
